import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const EULA = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1a0f0f] to-[#2d1810] py-20">
      <div className="container mx-auto px-6 max-w-4xl">
        {/* Back Button */}
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-orange-500 hover:text-orange-400 mb-8 transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
          Back to Home
        </button>

        {/* Content */}
        <div className="divine-card p-8 md:p-12">
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-white mb-4">
            End User License Agreement (EULA)
          </h1>
          <p className="text-gray-400 mb-8"><strong>Effective Date:</strong> December 4, 2025</p>

          <div className="space-y-6 text-gray-300 leading-relaxed">
            <p>
              This EULA governs your use of ShraddhaAI.
            </p>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">1. License Grant</h2>
              <p>
                We grant you a <strong>limited, non-exclusive, non-transferable license</strong> to use the app.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">2. Restrictions</h2>
              <p className="mb-2">You may not:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Reverse engineer the app</li>
                <li>Copy or distribute content</li>
                <li>Use the app for illegal purposes</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">3. AI Content Disclaimer</h2>
              <ul className="list-disc list-inside space-y-2 ml-4 mb-4">
                <li>All interactions are AI-generated</li>
                <li>Characters are <strong>fictional representations inspired by scriptures</strong></li>
                <li>They are <strong>not real divine entities</strong></li>
              </ul>

              <p className="mb-2"><strong>ShraddhaAI:</strong></p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Does not claim religious authority</li>
                <li>Does not guarantee correctness</li>
                <li>Does not provide professional advice</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">4. Subscription Usage</h2>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Features depend on your plan</li>
                <li>Voice/chat limits apply</li>
                <li>Coins and unlocks are digital assets only</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">5. Data Usage</h2>
              <p>
                Your use of the app is also governed by our Privacy Policy.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">6. Termination</h2>
              <p className="mb-2">We may terminate access if:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Terms are violated</li>
                <li>Misuse is detected</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">7. Liability</h2>
              <p className="mb-2">We are not liable for:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>User decisions</li>
                <li>Emotional outcomes</li>
                <li>Interpretation of content</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">8. Updates</h2>
              <p>
                We may update the app and terms at any time.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl font-bold text-white mb-4">9. Contact</h2>
              <div className="mt-4 p-4 bg-orange-500/10 border border-orange-500/20 rounded-lg">
                <p>Email: <a href="mailto:work.shraddhaai@gmail.com" className="text-orange-500 hover:text-orange-400">work.shraddhaai@gmail.com</a></p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EULA;